import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { useStoreLocatorPageData } from '@/api/tanStackQueries/storeLocator';
import { openLocalizationRail } from '@/localization/actions';
import { STORE_LOCATOR_PAGE_QUERY } from "@/storeLocator/constants";
import Routes from '@/router/routes';

export const useStoreLocator = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    const { data, isLoading, error } = useStoreLocatorPageData(STORE_LOCATOR_PAGE_QUERY);

    const handleOpenLocalizationRail = (): void => {
        dispatch(openLocalizationRail({ 
            handleAfterLocalizing: () => {
                router.push(Routes.HOME);
              }
         }));
    };

    return {
        data: data ?? null,
        isLoading,
        error,
        handleOpenLocalizationRail
    };
};